import clsx from 'clsx';
import { useState } from 'react';
import { IMAGE_BASE_URL } from '../constants/config';
import { Offer, YSH_GTM_EVENTS } from '../types/types';
import { isUserLoggedIn } from '../utils/auth';
import { useNavigate } from 'react-router-dom';
import { getTimeUntilStart } from '../utils/date-functions';
import { formatDays } from '../utils/util';
import { useRemindMe } from '../hooks/useRemindMe';
import { mapOfferToAnalyticsObject, pushToAnalytics } from '../utils/analytics';
import EmailConfirmationModal from './EmailConfirmationModal';
import Clover from '../assets/images/icons/offer/detelina.png';
import '../scss/offer.scss';

interface Props {
  offer: Offer;
  wide?: boolean;
}

const OfferAvailableSoon: React.FC<Props> = ({ offer, wide }) => {
  const [openModal, setOpenModal] = useState(false);
  const [email, setEmail] = useState('');
  const navigate = useNavigate();
  const isLoggedIn = isUserLoggedIn();

  const remindMeAction = useRemindMe(offer.id, {
    onSuccess: data => {
      setEmail(data.email);
      setOpenModal(true);
    }
  });

  const remindMeOnClick = () => {
    if (isLoggedIn) {
      pushToAnalytics({
        eventName: YSH_GTM_EVENTS.NOTIFY_ME,
        data: {
          coupon_details: [mapOfferToAnalyticsObject(offer, 'Uskoro dostupno')]
        }
      });

      remindMeAction.mutate();
    } else {
      navigate('/profil');
    }
  };

  const showSpecialLabel = Boolean(offer.label_text && offer.label_color);

  const { days, hours, minutes } = getTimeUntilStart(offer.date_start);

  return (
    <>
      <div className={clsx('offer mb-2', offer.is_advantage === 1 && 'advantage-offer', wide && 'offer--full-width')}>
        <div className="offer__image__filter" />
        <img
          className="offer__image"
          alt={`${offer.partner_name} - ${offer.name}`}
          src={`${IMAGE_BASE_URL}/${offer.image0}`}
          width={207}
          height={103}
          loading="eager"
          fetch-priority="high"
        />
        {offer.is_advantage === 1 && (
          <div className="advantage-offer__icon">
            <img src={Clover} width={22} />
          </div>
        )}
        <div className="offer__available-soon">
          {showSpecialLabel && (
            <div className={`offer__special-label offer__special-label--${offer.label_color}`}>{offer.label_text}</div>
          )}
          <section className="ps-2 pe-2 pb-2 offer-flex">
            <h3 className="offer__partner fz-16 mt-4 mb-2 font-yettel-bold">{offer.partner_name}</h3>
            <h4 className="offer__name font-yettel-light">{offer.name}</h4>
          </section>
          <section className="timer-info mt-4 font-yettel-bold fz-16">
            {(days > 0 || hours > 0 || minutes > 0) && (
              <span>
                {[days > 0 && `${days} ${formatDays(days)}`, hours > 0 && `${hours} h`, minutes > 0 && `${minutes} min`]
                  .filter(Boolean)
                  .join(' ') + ' do početka'}
              </span>
            )}
          </section>
          <section className="remind-me">
            {offer.hasReminder || email ? (
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <span>Obaveštenje stiže na mail</span>
              </div>
            ) : (
              <span onClick={remindMeOnClick} className="font-yettel-bold remind-me-button">
                Obavesti me
              </span>
            )}
          </section>
        </div>
      </div>
      {openModal && (
        <EmailConfirmationModal offer={offer} email={email} isModalActive={openModal} setIsModalActive={setOpenModal} />
      )}
    </>
  );
};

export default OfferAvailableSoon;
